const buddyEl = document.getElementById('buddy');
const buddyInner = buddyEl.querySelector('div');
const buddyOffsetX = buddyEl.clientWidth / 2;
const buddyOffsetY = buddyEl.clientHeight / 2;
const distanceOffset = 30;

const retriggerClassAnimation = (el, animClass) => {
  el.classList.remove(animClass);
  requestAnimationFrame((time) => {
    requestAnimationFrame((time) => {
      el.classList.add(animClass);
    });
  });
}

const init = () => {
  document.addEventListener('mousemove', e => {
    // Use pageX/pageY for document-relative coordinates (includes scroll offset)
    const { pageX: x, pageY: y } = e;
    
    // Calculate desired position
    let translateX = x - buddyOffsetX + distanceOffset;
    let translateY = y - buddyOffsetY + distanceOffset;
    
    // Get viewport dimensions for bounds checking
    const maxX = window.innerWidth - buddyEl.clientWidth;
    const maxY = window.innerHeight - buddyEl.clientHeight;
    
    // Get scroll offsets
    const scrollX = window.pageXOffset || window.scrollX || 0;
    const scrollY = window.pageYOffset || window.scrollY || 0;
    
    // Clamp to stay within viewport bounds (relative to current scroll position)
    translateX = Math.max(scrollX, Math.min(translateX, scrollX + maxX));
    translateY = Math.max(scrollY, Math.min(translateY, scrollY + maxY));
    
    buddyEl.style.transform = `translate(${ translateX }px, ${ translateY }px)`;
  });

  window.addEventListener('click', e => {
    console.log('click');
    retriggerClassAnimation(buddyInner, '_jiggle');
  });
}

window.addEventListener('load', e => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!prefersReducedMotion) {
    init();
  }
});